import api from "../api";

const state = {
  loading: false,
  response: []
};

const getters = {
  getLoading: state => state.loading,
  getResponse: state => state.response
};

const mutations = {
  TOGGLE_LOADING: (state, payload) => (state.loading = payload),
  SET_RESPONSE: (state, payload) => (state.response = payload)
};

const actions = {
  verifyEmail: async ({ commit }, payload) => {
    commit("TOGGLE_LOADING", true);
    let res = await api("get", payload.url);
    commit("TOGGLE_LOADING", false);
    commit("SET_RESPONSE", res);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
